import * as ActionTypes from 'actions/templateUpload'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  templateUploaded: [],
}

// Updates error message to notify about the failed fetches.
export default function templateUpload(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.TEMPLATE_UPLOAD_DELETE_RECEIVED:
    case ActionTypes.TEMPLATE_UPLOAD_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.TEMPLATE_UPLOAD_DELETE_COMPLETE:
    case ActionTypes.TEMPLATE_UPLOAD_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        templateUploaded: action.templateUploaded,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/templateUpload.js